import { useState, useEffect } from "react";

/**
 * 지정된 시간 후에 로딩 상태를 false로 변경하는 커스텀 훅
 * @param delay - 로딩 상태를 false로 변경하기까지의 지연 시간 (ms), 기본값 500ms
 * @returns isLoading - 로딩 상태
 */
function useDelayedLoading(delay: number = 500): boolean {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, delay);

        return () => clearTimeout(timer);
    }, [delay]);

    return isLoading;
}

export default useDelayedLoading;

